import { gql } from "@apollo/client"

export const VALIDATE_TAX_JAR = gql`
  query validateTaxJar($input: InputTaxJarConfig!) {
    Configuration {
      validate {
        taxJar(input: $input) {
          errorMessage
          valid
        }
      }
    }
  }
`
